module.exports = __webpack_public_path__ + "img/imposta-logo-jobmule.ed8ca850.png";